module.exports = __webpack_public_path__ + "img/House_4_Double_Brick.2673943c.jpg";